import React, { FunctionComponent, useState, useEffect } from "react";
import styles from "./DeleteSelectedModal.module.css";
import Modal from "react-modal";
import { connect, useDispatch } from "react-redux";
import Loading from "../../Loading/Loading";
import { showSnackbarAction } from "../../../Redux/actions";
import { motion } from "framer-motion";
import Backdrop from "../../Backdrop/Backdrop";
import PopUpBox from "../../../Screens/AuditLogs/PopUpBox";
import axiosHandler from "../../../Services/axiosHandler";
import { url } from "../../../Values/constants";
import { themeColors } from "../../theme";
import { softDeleteContacts ,restoreDataContacts} from "../../../Services/contacts";
import { AnyObject } from "yup/lib/object";

type Props = {
  open: boolean;
  close: () => void;
  data: any[];
  clearSelectedRowsData: any;
  setOwner?: any;
  theme: any;
  tableType?: any;
  newsData?: any;
  user: any;
  organizationId: any;
  history?: any;
  authToken: any;
  panel?: any;
  selectedRows?: any[];
  organizationData?: any;
};

const dropIn = {
  hidden: {
    y: "-100vh",
    opacity: 0,
  },
  visible: {
    y: "0",
    opacity: 1,
    transition: {
      duration: 1,
      type: "spring",
      damping: 25,
      stiffness: 500,
    },
  },
};

const DeleteSelectedModalSoftDelete: FunctionComponent<Props> = ({
  open,
  close,
  data,
  theme,
  user,
  selectedRows,
  organizationData,
  clearSelectedRowsData,
  panel
}) => {
  const [load, setLoad] = useState(false);
  const [popUpBox, setPopUpBox] = useState(false);
  const [isOtpVerified, setIsOtpVerified] = useState(false);
  const dispatcher = useDispatch();

  // useEffect(() => {
  //   if (isOtpVerified) {
  //     deleteData();
  //   }
  // }, [isOtpVerified]);

  const deleteData = async () => {
    setLoad(true);
    try {
      const data = await softDeleteContacts(selectedRows,setLoad,close,dispatcher,clearSelectedRowsData);
      // saveData();
    
    } catch (err: any) {
      console.error(err);
      dispatcher(showSnackbarAction("Failed to delete records", "error"));
      clearSelectedRowsData && clearSelectedRowsData();
      setLoad(false);
    }
  };

  const restoreData = async () => {
    setLoad(true);
    try {
      const data = await restoreDataContacts(selectedRows,setLoad,close,dispatcher,clearSelectedRowsData);
      // saveData()     
    } catch (err: any) {
      console.error(err);
      dispatcher(showSnackbarAction("Failed to delete records", "error"));
      clearSelectedRowsData && clearSelectedRowsData();
      setLoad(false);
    }
  };


  const customStyles = {
    content: {
      backgroundColor: theme ? themeColors.dropdownBackgroundColor : themeColors.dropdownBackgroundColorDark,
      color: theme ? themeColors.textPrimary : themeColors.textPrimaryDark,
    },
  };

  return (
    <>
      {load && <Loading />}
      <Backdrop>
        <motion.div
          key="modal"
          className="card p-4 shadow rounded"
          style={{
            position: "absolute",
            maxHeight: "320px",
            maxWidth: "320px",
            backgroundColor: theme ? themeColors.backgroundColor : themeColors.backgroundColorDark,
            color: theme ? themeColors.textPrimary : themeColors.textPrimaryDark,
          }}
          variants={dropIn}
          initial="hidden"
          animate="visible"
          exit="exit"
        >
          <h6>{panel==="contacts"?"Are you sure you want to delete the selected records?":"Are you sure you want to Restore the selected records?"}
          </h6>
          <div className={styles.container}>
            <ol>
              {data.map((dat: any) => (
                <li key={dat.contactId}>{dat.customer_name || dat.name}</li>
              ))}
            </ol>
          </div>
          <div className={styles.buttonView}>
            <button
              className={styles.cancelButton}
              onClick={() => {
                close();
                if (clearSelectedRowsData && panel === 'DeletedLogs') {
                  clearSelectedRowsData();
                  window.location.reload();
                }
              }}
            >
              Cancel
            </button>
            {panel === 'DeletedLogs' ? (<button className={styles.saveButton} onClick={restoreData}>
              Restore
            </button>) : (<button className={styles.saveButton} onClick={deleteData}>
              Delete
            </button>)}
          </div>
        </motion.div>
      </Backdrop>
      {/* {popUpBox && (
        <PopUpBox
          open={popUpBox}
          close={() => setPopUpBox(false)}
          setIsOtpVerified={setIsOtpVerified}
          setAuditLog={setPopUpBox}
          selectedRows={selectedRows}
          panel="contacts"
          operationType="delete"
        />
      )} */}
    </>
  );
};

const mapStateToProps = (state: any) => ({
  user: state.user.data,
  theme: state.theme.isLightMode,
  organizationId: state.organization.id,
  authToken: state.user.authToken,
  organizationData: state.organization.organizationData,
});

export default connect(mapStateToProps)(DeleteSelectedModalSoftDelete);
